module.exports = __webpack_public_path__ + "static/img/activity_sdy_04-1.a0be53e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_04-1.jpg
// module id = sJhS
// module chunks = 0